import { useEffect, useState } from 'react';

/**
 * Suit une media query CSS et re-rend quand elle change.
 * Ex. useMediaQuery('(max-width: 910px)') pour le breakpoint medium du DS.
 */
const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);

    useEffect(() => {
        const mediaQueryList = window.matchMedia(query);
        const handleChange = (event: MediaQueryListEvent) => setMatches(event.matches);
        setMatches(mediaQueryList.matches);
        mediaQueryList.addEventListener('change', handleChange);
        return () => mediaQueryList.removeEventListener('change', handleChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;
